import { Button, Typography, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import useStyles from "./dialogSelectBusinessStyles";

const DialogSelectBusiness = ({ open, onClose, businessesList, onSelect, history }) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const [selectedBusiness, setSelectedBusiness] = useState(null);

	useEffect(() => {
		if (open) {
			setSelectedBusiness(null);
		}
	}, [open]);

	useEffect(() => {
		if (open) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "unset";
		}
		return () => {
			document.body.style.overflow = "unset";
		};
	}, [open]);

	const businessOptions = businessesList.map((business) => ({
		value: business.id,
		label: business.name,
	}));

	const handleSelect = (option) => {
		setSelectedBusiness(option);
	};

	const handleConfirm = () => {
		if (selectedBusiness) {
			onSelect(selectedBusiness.value);
			history.push(`/business/${selectedBusiness.value}`);
			onClose();
		}
	};

	const handleCancel = () => {
		setSelectedBusiness(null);
		onClose();
	};

	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget) {
			handleCancel();
		}
	};

	if (!open) return null;

	return (
		<div className={classes.overlay} onClick={handleOverlayClick}>
			<div 
				className={classes.modal} 
				onClick={(e) => e.stopPropagation()}
			>
				<div className={classes.title}>
					<Typography variant="h6" style={{ fontWeight: "bold", fontSize: "20px" }}>
						{t("Select Business")}
					</Typography>
					<IconButton
						aria-label="close"
						onClick={handleCancel}
						className={classes.closeButton}
						size="small">
						<CloseIcon />
					</IconButton>
				</div>
				<div className={classes.content}>
					<Typography style={{ marginBottom: "15px", fontSize: "14px", color: "#666" }}>
						{t("Choose a business to schedule")}
					</Typography>
					<div style={{ width: "100%", position: "relative", zIndex: 1400 }}>
						<Select
							options={businessOptions}
							onChange={handleSelect}
							value={selectedBusiness}
							placeholder={t("Select a business")}
							isSearchable={false}
							blurInputOnSelect={true}
							styles={{
								control: (base) => ({
									...base,
									minHeight: 50,
									borderRadius: 8,
									border: "1px solid #ddd",
									width: "100%",
								}),
								menu: (base) => ({
									...base,
									zIndex: 9999,
									position: "absolute",
								}),
								menuPortal: (base) => ({
									...base,
									zIndex: 9999,
								}),
							}}
						/>
					</div>
				</div>
				<div className={classes.actions}>
					<Button
						className={classes.button}
						onClick={handleCancel}
						style={{
							backgroundColor: "#f5f5f5",
							color: "#666",
						}}>
						{t("Cancel")}
					</Button>
					<Button
						className={classes.button}
						onClick={handleConfirm}
						disabled={!selectedBusiness}
						style={{
							backgroundColor: selectedBusiness ? "#8C1837" : "#dddddd",
							color: selectedBusiness ? "#fff" : "#999",
						}}>
						{t("Confirm")}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default DialogSelectBusiness;

